export default __webpack_public_path__ + "static/media/React__3.8f6bdbb7.png";